/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/document';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RetrievePreliminaryCardholderAgreementDocumentRequest": {
                "fields": {}
              },
              "RetrievePreliminaryCardholderAgreementDocumentResponse": {
                "fields": {
                  "document": {
                    "type": ".squareup.corporate_card.resources.Document",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrievePreliminaryCardholderAgreementDocumentRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrievePreliminaryCardholderAgreementDocumentResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrievePreliminaryCardholderAgreementDocumentRequest @ squareup/corporate_card/service/retrieve_preliminary_cardholder_agreement_document.proto at 9:1
 */
export const RetrievePreliminaryCardholderAgreementDocumentRequest = $root.lookupType('squareup.corporate_card.service.RetrievePreliminaryCardholderAgreementDocumentRequest');
fixType(RetrievePreliminaryCardholderAgreementDocumentRequest);
Builder.createAndAttachToType(RetrievePreliminaryCardholderAgreementDocumentRequest);
/**
 * SOURCE RetrievePreliminaryCardholderAgreementDocumentResponse @ squareup/corporate_card/service/retrieve_preliminary_cardholder_agreement_document.proto at 15:1
 */
export const RetrievePreliminaryCardholderAgreementDocumentResponse = $root.lookupType('squareup.corporate_card.service.RetrievePreliminaryCardholderAgreementDocumentResponse');
fixType(RetrievePreliminaryCardholderAgreementDocumentResponse);
Builder.createAndAttachToType(RetrievePreliminaryCardholderAgreementDocumentResponse);